import './header.css';

function Header({ children, className }) {
  return <div className={['header', className].join(' ')}>{children}</div>;
}

export default Header;
